import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './static/css/utils.css'
import './routerGuard'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import horizontalScroll from 'el-table-horizontal-scroll'
Vue.use(ElementUI);
Vue.use(horizontalScroll)
import table from './components/table'
import message from './components/message'
import fromList from './components/fromList'
import detailList from './components/detailList'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
Vue.component('table-list', table)
Vue.component('message', message)
Vue.component('from-list', fromList)
Vue.component('detail-list', detailList)

import { asyncAjax, openError, getParams } from './utils/index'
Vue.prototype.$ajax = asyncAjax
Vue.prototype.$error = openError
Vue.prototype.$params = getParams

Vue.filter('filterBtnsRole', (btns, _route) => {
  let _role = '';
  let _btns = [];
  for (let i = 0; i < _route.matched.length; i++) {
    const item = _route.matched[i];
    if (item.meta && item.meta.role) _role = item.meta.role;
    if (item.path === _route.path) break;
  }
  _btns = btns.filter(item =>{
    return _role.includes(item.role);
  })
  return _btns;
})

// Vue.filter('filterBtns2', (btns, str) => {
//     const _roles = {};
//     console.log(store.getters['user/getAsyncRouter']);
//     const roles = store.getters['user/getUserInfo'].roles;
//     roles.forEach(item => {
//         if (item.match(new RegExp(str)) || item.match(/ALL/)) _roles[item] = true;
//     })
//     const _btns = [];
//     btns.forEach(btn => {
//         if (`${str}_${btn.role}` in _roles) _btns.push(btn)
//     })
//     return _btns;
//     return btns;
// })

// Vue.filter('filterBtns', (btns, str) => {
//     const _roles = {};
//     const roles = store.getters['user/getUserInfo'].roles;
//     roles.forEach(item => {
//         if (item.match(new RegExp(str)) || item.match(/ALL/)) _roles[item] = true;
//     })
//     const _btns = [];
//     function getBtn(com, btn) {
//         if (`${str}_${com}` in _roles || `ALL_${com}` in _roles) _btns.push(btn)
//     }
//     btns.forEach(btn => {
//         switch (btn.key) {
//             case 'add':
//                 getBtn('ADD', btn)
//                 return
//             case 'update':
//                 getBtn('Edit', btn)
//                 return
//             case 'delete':
//                 getBtn('Del', btn)
//                 return
//             case 'export':
//                 getBtn('Export', btn)
//                 return
//             default:
//                 _btns.push(btn)
//                 break;
//         }
//     });
//     return _btns;
// })


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
